import { ResponsivePie } from "@nivo/pie";

const percentageFormat = (value) => `${value}%`;
const dollarFormat = (actualAllocationRate) => {
  return actualAllocationRate.toLocaleString("en-US", {
    style: "currency",
    currency: "USD",
  });
};

const pieChartColorsMap = [
  "#A6CEE3",
  "#1F78B4",
  "#B2DF8A",
  "#33A02C",
  "#FB9A99",
  "#E31A1C",
  "#FDBF6F",
  "#FF7F00",
  "#CAB2D6",
  "#6A3D9A",
  "#FFFF99",
  "#B15928",
];

const AnnuityPieChart = ({ data = [], secondaryLegendData, actual, count }) => {
  //this is the implementation for unique colors for the two charts in case of unique values for each
  const first = pieChartColorsMap.slice(0, count);
  const second = pieChartColorsMap.slice(count).reverse();
  const color = actual ? first.concat(second) : pieChartColorsMap;

  return (
    <div className="annuity_pie_chart">
      <div className="w-50 pie_wrapper">
        <ResponsivePie
          data={data}
          innerRadius={0.8}
          valueFormat={percentageFormat}
          enableArcLabels={false}
          enableArcLinkLabels={false}
          colors={color}
          tooltip={({ datum: { id, value, color, label } }) => (
            <div
              style={{
                padding: 8,
                background: color,
                width: 100,
              }}
            >
              <strong> {label}</strong>
            </div>
          )}
          theme={{ tooltip: { container: { background: "#222222" } } }}
        />
        <div className="label-overlay">
          <h6>{data?.length}</h6>
          <small className="subtitle">
            {data?.length > 1 ? "Strategies" : "Strategy"}
          </small>
        </div>
      </div>

      <div className="no-select chart_legends">
        <table className="chart_table">
          <thead>
            <tr>
              <th className="text-nowrap min-width-150 font-normal">
                Crediting Strategy
              </th>
              <th className="text-nowrap font-normal text-center max-width-100">
                Allocation %
              </th>
              {actual ? (
                <th className="text-nowrap font-normal text-right max-width-100">
                  Strategy Value
                </th>
              ) : (
                <th
                  className="text-nowrap font-normal max-width-100"
                  style={{ visibility: "hidden" }}
                >
                  Strategy Value
                </th>
              )}
            </tr>
          </thead>
          <tbody>
            {data?.map(
              (
                { id, label, allocation, value, actualAllocationRate },
                index
              ) => (
                <tr>
                  <td className="min-width-150">
                    <div key={index} className="legends_label">
                      <span
                        className="rounded-circle legend_icon"
                        style={{ backgroundColor: color[index] }}
                      />
                      <p>{id}</p>
                    </div>
                  </td>
                  <td className="text-center text-xs" style={{ fontSize: 10 }}>
                    {allocation}
                  </td>
                  {actual ? (
                    <td className="text-right" style={{ fontSize: 10 }}>
                      {dollarFormat(actualAllocationRate)}
                    </td>
                  ) : (
                    <td></td>
                  )}
                </tr>
              )
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default AnnuityPieChart;
